import { Text } from 'recharts';

interface IRender {
  cx: number;
  cy: number;
  midAngle: number;
  innerRadius: number;
  outerRadius: number;
  percent: number;
  index: number;
}

const RADIAN = Math.PI / 180;

export const percentsCharts = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
}: IRender) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  const valuePercent = `${(percent * 100).toFixed(0)}%`;

  return (
    <Text
      x={x}
      y={y}
      fill={'white'}
      style={{
        fontWeight: valuePercent.length > 2 ? 600 : 700,
        fontSize: valuePercent.length > 2 ? '1.2rem' : '0.8rem',
        textShadow: valuePercent.length > 2 ? '0px 0px 3px #000' : '0px 0px 3px #000',
      }}
      textAnchor={valuePercent.length > 2 ? 'middle' : 'middle'}
      dominantBaseline="middle"
      alignmentBaseline="central"
      verticalAnchor="end"
    >
      {valuePercent}
    </Text>
  );
};
